export const getHospitalBillDocumentType = (documentTypes: any[]) => {
  if (!documentTypes?.length) {
    return null;
  }
  return documentTypes.find(
    (docType) => docType?.label?.toUpperCase() === "HOSPITAL BILL",
  );
};

export const getDischargeSummaryDocumentType = (documentTypes: any[]) => {
  if (!documentTypes?.length) {
    return null;
  }
  return documentTypes.find(
    (docType) => docType?.label?.toUpperCase() === "DISCHARGE SUMMARY",
  );
};

export const getOthersDocumentType = (documentTypes: any[]) => {
  if (!documentTypes?.length) {
    return null;
  }
  return documentTypes.find(
    (docType) => docType?.label?.toUpperCase() === "OTHERS",
  );
};

export const isIpOrEmergencyVisit = (visitType?: string | null) => {
  const normalized = visitType?.trim()?.toUpperCase();
  return normalized === "IP" || normalized === "EMERGENCY";
};

export const DS_ROW_KEY = -1;
export const OTHERS_ROW_KEY = -2;

export const isSyntheticReconRow = (row?: {
  documentKind?: string;
  reconId?: number;
} | null) => {
  if (!row) {
    return false;
  }
  const kind = row.documentKind?.toUpperCase();
  return (
    kind === "DS" ||
    kind === "OTHERS" ||
    row.reconId === DS_ROW_KEY ||
    row.reconId === OTHERS_ROW_KEY
  );
};
